import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'

interface UnifiedCurrency {
  id: string
  name: string
  symbol?: string
  isoName?: string
  currencyRatio?: number
  isActive: boolean
}

export function useUnifiedCurrency() {
  const { data, isLoading, error } = useQuery<UnifiedCurrency>({
    queryKey: ['unifiedCurrency'],
    queryFn: async () => {
      const response = await apiClient.get(API_ENDPOINTS.currencies.unified)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
    retry: 2,
  })

  return {
    unifiedCurrency: data,
    isLoading,
    error,
    currencyId: data?.id,
    currencySymbol: data?.symbol || 'ر.س',
    currencyName: data?.name || 'SAR',
  }
}


